import {useLang} from "../context/LanguageContext";
import Lottie from "lottie-react";
import loadingAnimation from "../lotties/loading_ball.json";


const Loading = () => {
    const { t } = useLang();

    return (
        <div className="flex flex-col items-center">
            <Lottie
                animationData={loadingAnimation}
                style={{width: 150, height: 150}}
            />
            <p className="text-sm text-gray-500">{t('txt.pleaseWait')}</p>
        </div>
    )
}

export default Loading;